<template>
    <div v-show="notifyBox" class="notify-box" @mouseover="showCloseButton" @mouseout="hideCloseButton">
        <p v-show="closeButton" class="close-icon" @click="closeNotification">x</p>
        <div class="content-box">
            <p class="notify-message">{{message}}</p>
            <!-- <p class="notify-action">{{action}}</p> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "notification-box",
        props: ['action','message'],
        data() {
            return {
                notifyBox: false,
                closeButton: true,
            }
        },
        methods: {
            showCloseButton() { this.closeButton = true; },
            hideCloseButton() { this.closeButton = false; },
            closeNotification() { this.notifyBox = false; },
        }
    }
</script>

<style scoped>
    p {
        margin: 0;
        padding: 0;
    }

    .notify-box {
        position: absolute;
        bottom: 40px;
        left: 40px;
        width: 360px;
        box-sizing: border-box;
    }

    .content-box {
        padding: 16px;
        position: relative;
        border-radius: 5px;
        border: 1px solid rgba(217, 80, 64, 0.2);
        background: white;
    }

    .notify-message {
        color: #5F5F5F;
        font-size: 13px;
        line-height: 18px;
        margin-bottom: 16px;
    }

    .notify-action {
        color: #D95040;
        font-size: 12px;
        font-weight: bold;
        cursor: pointer;
    }

    .close-icon {
        background: rgba(255, 255, 255, 0.75);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0.5rem;
        color: #D95040;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 1ms ease-in-out;
        cursor: pointer;
        margin-bottom: 2.5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Notifications/NotifyBox.vue